import { scopedCreator } from 'ha/myredux/createAction';
import * as Actions from '../constants/Actions';

const createAction = scopedCreator(Actions.PREFIX);

export const addFiles = createAction('addFiles');
export const removeFile = createAction('removeFile');
export const setMessage = createAction('setMessage');
export const setRtcState = createAction('setRtcState');
export const load = createAction.request('load');

export const sendMessageAction = createAction.request('sendMessage');
export const sendFileAction = createAction.request('sendFile');
export const makeRequestAction = createAction.request('makeRequest');
export const markAsReadAction = createAction.request('markAsReadAction');

export const setMakingSpecialOffer = createAction(
  'setMakingSpecialOffer',
  () => null,
);
export const unsetMakingSpecialOffer = createAction(
  'unsetMakingSpecialOffer',
  () => null,
);

export const setRequestingAnotherDates = createAction(
  'setRequestingAnotherDates',
  () => null,
);
export const unsetRequestingAnotherDates = createAction(
  'unsetRequestingAnotherDates',
  () => null,
);

export const setDeclining = createAction('setDeclining', () => null);
export const unsetDeclining = createAction('unsetDeclining', () => null);
